<template>
  <div>
    <div v-if="loading" class="text-xs-center my-5 pt-5">
      <v-progress-circular :size="50" color="black" indeterminate />
    </div>
    <v-container v-else fluid grid-list-xl px-0 py-2>
      <v-layout row wrap>
        <v-flex xs12 sm5 md3 v-if="$vuetify.breakpoint.mdAndUp">
          <base-card color="secondary">
            <tk-media
              v-if="post.media"
              sizes="400px"
              height="250px"
              :media="post.media"
              lazy-src="/static/img/placeholder.png"
              :style="{'background-color': post.media.color }"
            />

            <div class="pa-3">
              <div class="tite">{{ post.publish_date }}</div>
              <h2 class="headline mt-3 font-weight-bold">{{ post.title}}</h2>
            </div>
            <div class="text-xs-center pb-4">
              <tk-btn flat class="social-icon" @click="share.facebook()">
                <v-icon>fab fa-facebook-f</v-icon>
              </tk-btn>
              <tk-btn flat class="social-icon" @click="share.twitter()">
                <v-icon>fab fa-twitter</v-icon>
              </tk-btn>
              <tk-btn flat class="social-icon" @click="share.linkedin()">
                <v-icon>fab fa-linkedin-in</v-icon>
              </tk-btn>
            </div>
          </base-card>
        </v-flex>
        <v-flex xs12 md9 class="subpage">
          <div class="page-container">
            <h1>{{ post.title }}</h1>
            <tk-froala :content="post.content" class="mt-4" />
          </div>
        </v-flex>
      </v-layout>

      <div v-if="latest_posts.length" class="mt-5">
        <h1
          class="display-2 font-weight-light font-miller-display decorated mb-4"
          v-html="$t('COMMON.LATEST_NEWS')"
        ></h1>
        <v-layout row wrap mb-4>
          <v-flex xs12 sm6 md3 v-for="post in latest_posts" :key="post.id">
            <v-hover>
              <base-card
                slot-scope="{ hover }"
                color="secondary"
                :class="{'elevation-12 scale-down' : hover}"
                :to="{ name: 'news.single', params: { newsSlug: post.slug }}"
              >
                <v-img
                  v-if="post.media"
                  sizes="300px"
                  height="250px"
                  :src="post.media.url"
                  :srcset="post.media.srcset"
                  :style="{'background-color': post.media.color }"
                />

                <v-card-title primary-title>
                  <div class="content-area">
                    <h3 class="heading">{{ post.title }}</h3>
                    <span class="grey--text text--darken-3">{{ post.publish_date }}</span>
                    <div class="mt-2">{{ post.excerpt }}</div>
                  </div>
                </v-card-title>
              </base-card>
            </v-hover>
          </v-flex>
        </v-layout>

        <div class="text-xs-center">
          <tk-btn dark color="black" large :to="{name: 'news'}">
            <span class="caption font-weight-medium">{{ $t('COMMON.SEE_ALL_NEWS') }}</span>
          </tk-btn>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import * as SocialShare from "@/utils/SocialShare";

import { ErrorHandler } from "@/utils/ErrorHandler";
const handler = new ErrorHandler();

export default {
  props: ["newsSlug"],

  components: {
    TkFroala: () => import("@/components/core/TkFroala"),
  },

  data() {
    return {
      loading: true,
      post: {},
      share: SocialShare,
      latest_posts: [],
    };
  },

  created() {
    this.fetchData();
  },

  watch: {
    // call again the method if the route changes
    $route: "fetchData",
  },

  methods: {
    async fetchData() {
      this.loading = true;
      await handler.handle(async () => {
        // Translations required while changing locale
        const res = await this.$axios.get(
          `posts/${this.newsSlug}?include=translations,media`
        );
        this.post = res.data["data"];

        // Used for locale change route
        this.$route.meta.translations = res.data["data"]["translations"];

        console.log(this.$route);

        this.$app.setTitle(this.post.title);

        this.fetchLatestPosts();
      });
      this.loading = false;
    },

    async fetchLatestPosts() {
      console.log("this.fetchLatestPosts)");

      await handler.handle(async () => {
        const post_res = await this.$axios.get(
          `posts?include=media&limit=4&filter[exclude]=${this.post.id}`
        );
        this.latest_posts = post_res.data["data"];
      });

    },
  },
};
</script>